import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GestionRegionComponent } from 'src/app/core/gestion-referentiel/gestion-region/gestion-region.component';
import { SpinnerModalComponent } from '../spinner/spinner-modal.component';
import { SocieteModel } from 'src/app/shared/models/rsa/societe.model';
import { SocieteService } from 'src/app/shared/services/rsa/societe.service';

export interface DialogData {
  form: UntypedFormGroup;
  result: boolean;
}

@Component({
  selector: 'app-modal-add-societe',
  templateUrl: './modal-add-societe.component.html',
  styleUrls: ['./modal-add-societe.component.scss']
})
export class ModalAddSocieteComponent implements OnInit {
  
  societe: SocieteModel;
  form: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<GestionRegionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private societeService: SocieteService,
    public dialog: MatDialog,
    private router: Router,
    private toastService: ToastrService) { }

  ngOnInit(): void {
    this.form = this.data.form
  }

  closeDialog(val: boolean): void {
    this.dialogRef.close(val);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      const societe = this.form.getRawValue();
      societe.type = "Societe";
      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.societeService.save(societe).subscribe((a: SocieteModel) => {
            this.toastService.success('', 'Création de la société ' + a.libelle + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            dialogRef.close();
          });
      }else { // Modification
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.societeService.update(societe.id, societe).subscribe((a: SocieteModel) => {
          this.toastService.success('', 'Modification de la société ' + a.libelle + ' réussie');
          this.dialogRef.close(true);
          dialogRef.close();
        }, (error) => {
          dialogRef.close();
        });
      }
    } else {
      this.displayErrors();
      this.toastService.warning('', 'Veuillez remplir les champs obligatoires correctement');
    }
  }

  displayErrors(): void {
    for (const index in this.form.controls) {
      if (index) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}

